export const VENTAS = 1;
export const LOGISTICA = 2;